export default __webpack_public_path__ + "static/media/köide-28-29.a93df6da.png";